<template>
  <div
    v-if="patient"
    class="patient-sidepanel ap-sidepanel p-3 d-flex flex-column"
  >
    <div class="main text-center d-flex justify-content-between mb-2">
      <span>{{ $t('component.patient.searcher.patientInformation') }}</span>
      <b-button
        class="btn__icon btn__icon--primary p-0 pr-0"
        @click="closePatientSidepanel"
      >
        <i
          class="far fa-times"
          aria-hidden="true"
        />
      </b-button>
    </div>
    <div class="patient-sidepanel__container flex-grow-1 mh-0">
      <b-row class="mt-3 patient-sidepanel__row h-100 mh-0 pb-3">
        <b-col class="patient-sidepanel__main-col h-100">
          <b-tabs
            ref="tabs"
            pills
            card
            vertical
            class="vt-tabs--vertical h-100 overflow-y-auto"
          >
            <b-tab lazy>
              <template slot="title">
                <i
                  class="far fa-user-circle"
                  aria-hidden="true"
                />
              </template>
              <div class="ml-2">
                <b-row class="content-scroll">
                  <b-col class="mt-3">
                    <patient-info
                      v-if="patient"
                      :patient="patient"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-tab>
            <b-tab
              v-if="patient.attachmentsCount"
              lazy
            >
              <template slot="title">
                <i
                  class="far fa-paperclip"
                  aria-hidden="true"
                />
                <div class="section-indicator">
                  <vtBubble
                    :number="patient.attachmentsCount"
                    :type="false"
                    class="mr-1"
                  />
                </div>
              </template>
              <div class="ml-2">
                <b-row class="content-scroll">
                  <b-col
                    class="py-3 fixed-header"
                    cols="12"
                  >
                    <span class="title">{{ $tc('global.file', 2) }}</span>
                  </b-col>
                  <b-col cols="12">
                    <patient-attachments-info
                      ref="patientAttachmentsInfo"
                      :patient-id="patientId"
                      @onDeleteAttachment="onDeleteAttachment"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-tab>
            <b-tab
              v-if="patient.incidentsCount"
              lazy
            >
              <template slot="title">
                <i
                  class="far fa-exclamation-triangle"
                  aria-hidden="true"
                />
                <div class="section-indicator">
                  <vtBubble
                    :number="patient.incidentsCount"
                    :type="true"
                    class="mr-1"
                  />
                </div>
              </template>
              <div class="ml-2">
                <b-row class="content-scroll">
                  <b-col
                    class="py-3 fixed-header"
                    cols="12"
                  >
                    <span class="title">{{ $tc('global.incident', 2) }}</span>
                  </b-col>
                  <b-col cols="12">
                    <patient-incidents-info :patient-id="patientId" />
                  </b-col>
                </b-row>
              </div>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import patientResource from '@/api/resources/PatientResource'
import PatientInfo from '@/components/searcherPatientModal/PatientInfo'
import PatientAttachmentsInfo from '@/components/searcherPatientModal/PatientAttachmentsInfo'
import PatientIncidentsInfo from '@/components/searcherPatientModal/PatientIncidentsInfo'

export default {
    name: 'PatientSidepanel',
    components: {
        VtBubble,
        PatientInfo,
        PatientAttachmentsInfo,
        PatientIncidentsInfo
    },
    props: {
        patientId: { type: Number }
    },
    data() {
        return {
            patient: null
        }
    },
    created() {
        this.loadPatientById()
    },
    methods: {
        closePatientSidepanel() {
            this.$emit('closePatientSidepanel', false)
        },
        async loadPatientById() {
            const [err, response] = await this.toCall(patientResource.findById(this.patientId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return false
            }
            this.patient = response
            return true
        },
        async loadPatientAttachments() {
            await this.loadPatientById()
            if (this.$refs.patientAttachmentsInfo) {
                await this.$refs.patientAttachmentsInfo.getAttachments()
            }
        },
        onDeleteAttachment(attachmentCount) {
            this.patient.attachmentsCount = attachmentCount
        }
    }
}

</script>

<style lang="scss">
.patient-sidepanel {
    position: absolute;
    width: 550px;
    height: 100%;
    background: #FFF;
    z-index: 1;
    right: 0;
    box-shadow: -5px 0 5px -5px #b2b2b2;
    border: 1px solid vt-color(grid-general-border);
}
.patient-sidepanel .incident-card .header {
    font-size: font-size(small);
}

.patient-sidepanel .tabs.row {
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.patient-sidepanel .vt-tabs .nav-tabs .nav-link.active,
.vt-tabs--small .nav-tabs .nav-link.active {
    border-bottom: 2px solid vt-color(primary);
}

.patient-sidepanel .vt-tabs .nav-tabs .nav-link,
.vt-tabs--small .nav-tabs .nav-link {
    border-bottom: 2px solid transparent;
}

.patient-sidepanel .vt-tabs .nav-tabs .nav-link,
.vt-tabs--small .nav-tabs .nav-link i {
    font-size: font-size(very-normal) !important;
}

.patient-sidepanel .techniques-tab .nav-link.active::before {
    background: transparent;
}
.patient-sidepanel .section-indicator{
    position: absolute;
    width: auto;
    left: 23px;
    margin-top: 5px;
}
.patient-sidepanel .title {
    color: vt-color(primary);
}
.patient-sidepanel .fixed-header {
    background: vt-color(white-light);
    position: sticky;
    top: 0;
    z-index: 1;
}
.patient-sidepanel .content-scroll {
    overflow-y: auto;
    overflow-x: hidden;
}
.patient-sidepanel .vt-tabs--vertical {
    flex-grow: 1;
    min-height: 0;
}
.patient-sidepanel .vt-tabs--vertical .tab-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
}
</style>
